<template>
    <b-navbar toggleable class="inner-left-sidebar">
    <div class="full-width">
        <router-link tag="button" type="button" class="navbar-toggler" :to="{ name: 'user_awards' }" exact>
            <span :class="{ 'active': $route.name === 'user_awards' }">Awards</span>
        </router-link>
    </div>
    
    <div class="full-width">
        <router-link tag="button" type="button" class="navbar-toggler" :to="{ name: 'members_directory' }" exact>
            <span :class="{ 'active': $route.name === 'members_directory' }">Members Directory</span>
        </router-link>
    </div>
    <div class="full-width">
        <router-link tag="button" type="button" class="navbar-toggler" :to="{ name: 'custom_forms' }" exact>
            <span :class="{ 'active': $route.name === 'custom_forms' }">Custom Forms</span>
        </router-link>
    </div>
    <div class="full-width">
        <router-link tag="button" type="button" class="navbar-toggler" :to="{ name: 'vendors' }" exact>
            <span :class="{ 'active': $route.name === 'vendors' }">Vendors</span>
        </router-link>
    </div>
</b-navbar>

</template>

<script>
export default {
    name: 'ResourceSidebar'
}
</script>